<script>
  export let name = ''
  export let school = ''
  export let city = ''
  export let state = ''
  export let years = []
  export let disciplines = []
  export let parentDisciplines = []
  export let childDisciplines = []
  export let awardLevels = []
  export let subdisciplineModifier = ''
</script>

<div>
  <div class="leading-snug text-base">
    <h3 class="font-bold font-sans text-base">{@html name}</h3>
    <div>
      {#if parentDisciplines.length && childDisciplines.length}  
        {#each parentDisciplines as item, i} <span class="">{@html item.name}</span>{/each}/{#each childDisciplines as item, i}<span class="">{@html item.name}</span>{/each}{#if subdisciplineModifier}: {subdisciplineModifier}{/if}
      {:else}
        {#each disciplines as item, i}
          <span class="">{item.name}</span>
        {/each}
      {/if}
    </div>
    {#if awardLevels.length}
      <div class="text-gray-500">{awardLevels[0].name !== 'Winner' ? awardLevels[0].name : ''}</div>
    {/if}
    {#if years.length}
      <div class="text-gray-500">{years[0].name}</div>
    {/if}
  </div>
  
  <div class="text-sm leading-normal mt-2">
    {#if school}<div>{school}</div>{/if}
    <div>{#if city}{city}{/if}{#if state}, {state}{/if}</div>
  </div>
</div>